import script from "./MmMaterialsFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./MmMaterialsFilters.vue?vue&type=script&setup=true&lang=js"

import "./MmMaterialsFilters.vue?vue&type=style&index=0&id=10d37f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d37f72"]])

export default __exports__